module.exports = __webpack_public_path__ + "media/music/51a75dd50afd0bc6022dfc86455be19c.mp3";